/* Mini-coșul MundiShop — panou lateral care se deschide la orice „Adaugă în coș",
   cu drum direct spre checkout. Autonom: nu depinde de alte scripturi ale temei.
   1) interceptează formularul de pe pagina de produs (AJAX, fără redirect la /cart);
   2) după adăugarea de pe cardurile din listă (.addc, făcută de mundi.js), doar deschide panoul;
   3) butoanele „Adaugă în coș" din afara formularului declanșează același flux. */
(function () {
  'use strict';
  if (window.__mundiMinicart) return;
  window.__mundiMinicart = true;

  var css = '' +
  '#mcbg{position:fixed;inset:0;background:rgba(20,22,26,.45);opacity:0;pointer-events:none;transition:opacity .2s;z-index:1200}' +
  '#mcbg.on{opacity:1;pointer-events:auto}' +
  '#mcdrawer{position:fixed;top:0;right:0;height:100vh;height:100dvh;width:min(440px,100vw);background:#fff;z-index:1201;' +
    'transform:translateX(102%);transition:transform .25s ease;display:flex;flex-direction:column;' +
    'box-shadow:-12px 0 40px rgba(20,22,26,.18);font-family:Nunito,"Helvetica Neue",Helvetica,Arial,sans-serif;color:#14161A}' +
  '#mcdrawer.on{transform:none}' +
  '.mc-h{display:flex;align-items:center;justify-content:space-between;padding:14px 12px 14px 20px;border-bottom:1px solid #E3E7EE}' +
  '.mc-h h3{margin:0;font-size:18px;font-weight:800}' +
  '.mc-h h3 span{font-weight:600;color:#5F6673;font-size:14px;margin-left:4px}' +
  '.mc-h button{border:0;background:none;font-size:20px;cursor:pointer;line-height:1;width:44px;height:44px;border-radius:6px;color:#14161A}' +
  '.mc-h button:hover{background:#F4F6FA}' +
  '.mc-items{flex:1;overflow-y:auto;padding:4px 20px}' +
  '.mc-empty{padding:36px 0 24px;text-align:center}' +
  '.mc-empty p{margin:0 0 6px;font-size:17px;font-weight:800}' +
  '.mc-empty small{display:block;color:#5F6673;font-size:14px;margin-bottom:18px}' +
  '.mc-empty a{display:inline-flex;align-items:center;justify-content:center;min-height:44px;padding:0 18px;margin:0 4px 8px;border-radius:6px;' +
    'border:1.5px solid #C9D0DB;color:#14161A;font-weight:700;font-size:14px;text-decoration:none}' +
  '.mc-empty a:hover{border-color:#14161A}' +
  '.mc-row{display:grid;grid-template-columns:76px 1fr;gap:14px;padding:16px 0;border-bottom:1px solid #E3E7EE}' +
  '.mc-row img{width:76px;height:76px;object-fit:contain;border-radius:8px;background:#F4F6FA;border:1px solid #E3E7EE;display:block}' +
  '.mc-m{font-size:11.5px;color:#5F6673;margin:0 0 3px;display:flex;gap:8px;flex-wrap:wrap}' +
  '.mc-t{font-size:14px;font-weight:700;line-height:1.3;margin:0 0 8px;color:#14161A;text-decoration:none;display:block}' +
  '.mc-t:hover{color:#0055D4}' +
  '.mc-b{display:flex;align-items:center;justify-content:space-between;gap:10px;flex-wrap:wrap}' +
  '.mc-qty{display:inline-flex;align-items:center;border:1.5px solid #C9D0DB;border-radius:6px;overflow:hidden}' +
  '.mc-qty button{border:0;background:#fff;width:36px;height:34px;cursor:pointer;font-size:17px;color:#14161A;font-family:inherit}' +
  '.mc-qty button:hover{background:#F4F6FA}' +
  '.mc-qty span{min-width:30px;text-align:center;font-size:14px;font-weight:700}' +
  '.mc-r{text-align:right}' +
  '.mc-p{font-weight:800;font-size:15px;white-space:nowrap}' +
  '.mc-u{display:block;font-size:11.5px;color:#5F6673;font-weight:600;margin-top:2px}' +
  '.mc-x{border:0;background:none;color:#5F6673;cursor:pointer;font-size:12.5px;font-weight:600;padding:8px 0 0;font-family:inherit;text-decoration:underline;text-underline-offset:2px}' +
  '.mc-x:hover{color:#D42B1F}' +
  '.mc-f{border-top:1px solid #E3E7EE;padding:12px 20px 16px;background:#fff}' +
  '.mc-sub{display:flex;justify-content:space-between;align-items:baseline;font-size:15px;font-weight:600;margin-bottom:2px}' +
  '.mc-sub b{font-size:22px;font-weight:800;letter-spacing:-.02em}' +
  '.mc-ship{font-size:12.5px;color:#5F6673;margin-bottom:12px}' +
  '.mc-checkout{display:flex;align-items:center;justify-content:center;width:100%;min-height:50px;border-radius:6px;' +
    'background:#0055D4;color:#fff;font-weight:800;font-size:15.5px;text-decoration:none}' +
  '.mc-checkout:hover{background:#0047B3;color:#fff}' +
  '.mc-links{display:flex;justify-content:space-between;gap:12px;margin-top:10px}' +
  '.mc-view{font-size:13.5px;color:#14161A;font-weight:700}' +
  '.mc-view:hover{color:#0055D4}' +
  '.mc-g{list-style:none;margin:12px 0 0;padding:10px 0 0;border-top:1px solid #E3E7EE;display:grid;grid-template-columns:1fr 1fr;gap:6px 12px}' +
  '.mc-g li{font-size:12px;color:#5F6673;font-weight:600;padding-left:16px;position:relative;line-height:1.35}' +
  '.mc-g li:before{content:"";position:absolute;left:0;top:5px;width:8px;height:8px;border-radius:50%;background:#0B7A4B}' +
  '.mc-note{font-size:13px;color:#B3400F;padding:8px 20px 0;display:none;font-weight:600}' +
  '@media(max-width:640px){#mcdrawer{width:100vw}}' +
  '@media(prefers-reduced-motion:reduce){#mcdrawer,#mcbg{transition:none}}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  var bg = document.createElement('div'); bg.id = 'mcbg';
  var dr = document.createElement('aside'); dr.id = 'mcdrawer';
  dr.setAttribute('role', 'dialog'); dr.setAttribute('aria-label', 'Coșul meu');
  dr.innerHTML =
    '<div class="mc-h"><h3>Coșul meu <span id="mccount"></span></h3>' +
    '<button type="button" id="mcclose" aria-label="Închide">✕</button></div>' +
    '<div class="mc-note" id="mcnote"></div>' +
    '<div class="mc-items" id="mcitems"></div>' +
    '<div class="mc-f">' +
      '<div class="mc-sub"><span>Subtotal</span><b id="mcsub"></b></div>' +
      '<div class="mc-ship">+ 25 lei livrare prin Cargus, oriunde în România (24–72 ore)</div>' +
      '<a class="mc-checkout" href="/checkout">Finalizează comanda</a>' +
      '<div class="mc-links"><a class="mc-view" href="/cart">Vezi coșul complet</a><a class="mc-view" href="/collections/lego">Continuă cumpărăturile</a></div>' +
      '<ul class="mc-g"><li>Livrare în 24–72 de ore, prin Cargus</li><li>Produse noi, sigilate</li><li>Retur în 14 zile</li><li>Plată cu cardul sau ramburs</li></ul>' +
    '</div>';
  function monteaza(){ document.body.appendChild(bg); document.body.appendChild(dr); }
  if (document.body) monteaza(); else document.addEventListener('DOMContentLoaded', monteaza);

  function lei(b) {
    var n = (b / 100).toFixed(2).split('.');
    return n[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + n[1] + ' lei';
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function poza(u) {
    if (!u) return '';
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160';
  }

  var busy = false;
  function show() { bg.classList.add('on'); dr.classList.add('on'); document.documentElement.style.overflow = 'hidden'; }
  function hide() { bg.classList.remove('on'); dr.classList.remove('on'); document.documentElement.style.overflow = ''; }
  bg.addEventListener('click', hide);
  dr.addEventListener('click', function (e) { if (e.target.id === 'mcclose' || e.target.closest('#mcclose')) hide(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') hide(); });

  function nota(t) {
    var n = dr.querySelector('#mcnote');
    if (t) { n.textContent = t; n.style.display = 'block'; } else { n.textContent = ''; n.style.display = 'none'; }
  }

  function badge(count) {
    ['a[href$="/cart"] sup', 'a[href*="/cart"] sup', '.cart-count', '[data-cart-count]', '#cartcount'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.textContent = count; });
    });
  }

  function render(cart) {
    var list = dr.querySelector('#mcitems');
    dr.querySelector('#mccount').textContent = '(' + cart.item_count + ')';
    dr.querySelector('#mcsub').textContent = lei(cart.items_subtotal_price);
    badge(cart.item_count);
    (function () {
      var isV = function (it) { var t = it.product_type || ''; return t === 'Figurine' || t.indexOf('Bebe - ') === 0; };
      var nv = cart.items.filter(isV).length, nl = cart.items.length - nv;
      var s = dr.querySelector('.mc-ship'), g = dr.querySelectorAll('.mc-g li');
      if (!s) return;
      if (nv && nl) { s.textContent = '+ livrare Cargus pentru fiecare colet (LEGO în 24–72 ore, Viva Toys în 2–4 zile lucrătoare)'; if (g[0]) g[0].textContent = 'Două colete, livrate separat prin Cargus'; if (g[1]) g[1].textContent = 'Produse noi, originale'; }
      else if (nv) { s.textContent = '+ livrare prin Cargus, oriunde în România (2–4 zile lucrătoare)'; if (g[0]) g[0].textContent = 'Livrare în 2–4 zile lucrătoare, prin Cargus'; if (g[1]) g[1].textContent = 'Produse noi, originale'; }
      else { s.textContent = '+ 25 lei livrare prin Cargus, oriunde în România (24–72 ore)'; if (g[0]) g[0].textContent = 'Livrare în 24–72 de ore, prin Cargus'; if (g[1]) g[1].textContent = 'Produse noi, sigilate'; }
    })();
    if (!cart.items.length) {
      list.innerHTML = '<div class="mc-empty"><p>Coșul tău e gol</p><small>Alege un set și îl trimitem în 24–72 de ore.</small>' +
        '<a href="/collections/noutati-hituri">Noutăți</a><a href="/collections/reduceri">Reduceri</a><a href="/collections/lego">Toate seturile</a></div>';
      return cart;
    }
    var h = '';
    cart.items.forEach(function (it, i) {
      var meta = [];
      if (it.product_type) meta.push(esc(it.product_type));
      if (it.sku) meta.push(esc(it.sku));
      if (it.variant_title && it.variant_title !== 'Default Title') meta.push(esc(it.variant_title));
      h += '<div class="mc-row" data-line="' + (i + 1) + '">' +
        '<a href="' + it.url + '" tabindex="-1" aria-hidden="true"><img src="' + poza(it.image) + '" alt="" loading="lazy" width="76" height="76"></a>' +
        '<div>' +
          (meta.length ? '<p class="mc-m">' + meta.map(function (m) { return '<span>' + m + '</span>'; }).join('') + '</p>' : '') +
          '<a class="mc-t" href="' + it.url + '">' + esc(it.product_title) + '</a>' +
          '<div class="mc-b">' +
            '<span class="mc-qty">' +
              '<button type="button" data-q="-1" aria-label="Scade cantitatea">−</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-q="1" aria-label="Crește cantitatea">+</button>' +
            '</span>' +
            '<div class="mc-r"><div class="mc-p">' + lei(it.final_line_price) + '</div>' +
              (it.quantity > 1 ? '<span class="mc-u">' + it.quantity + ' × ' + lei(it.final_price) + '</span>' : '') +
            '</div>' +
          '</div>' +
          '<button type="button" class="mc-x" data-del>Șterge din coș</button>' +
        '</div>' +
      '</div>';
    });
    list.innerHTML = h;
    return cart;
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(render);
  }

  dr.addEventListener('click', function (e) {
    var b = e.target.closest('button'); if (!b || busy) return;
    var row = e.target.closest('.mc-row'); if (!row) return;
    var line = +row.getAttribute('data-line');
    var qEl = row.querySelector('.mc-qty span');
    var q = qEl ? +qEl.textContent : 1;
    var newQ = null;
    if (b.hasAttribute('data-del')) newQ = 0;
    else if (b.hasAttribute('data-q')) newQ = Math.max(0, q + +b.getAttribute('data-q'));
    if (newQ === null) return;
    busy = true;
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: newQ })
    }).then(function (r) { return r.json(); }).then(render)
      ['catch'](function () {})
      ['finally'](function () { busy = false; });
  });

  function addFromForm(form) {
    if (busy) return; busy = true; nota('');
    var btn = form.querySelector('[type="submit"]');
    var old = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = 'Se adaugă…'; }
    var fd = new FormData(form);
    if (!fd.get('quantity')) fd.set('quantity', '1');
    fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', body: fd })
      .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
      .then(refresh).then(show)
      ['catch'](function (err) {
        refresh().then(show);
        nota((err && (err.description || err.message)) || 'Nu am putut adăuga produsul. Încearcă din nou.');
      })
      ['finally'](function () {
        busy = false;
        if (btn) { btn.disabled = false; btn.textContent = old || 'Adaugă în coș'; }
      });
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.getAttribute && (f.getAttribute('action') || '').indexOf('/cart/add') !== -1) {
      e.preventDefault(); e.stopImmediatePropagation();
      addFromForm(f);
    }
  }, true);

  document.addEventListener('click', function (e) {
    var b = e.target.closest('.addc');
    if (!b || b.classList.contains('addc--out') || b.closest('form')) return;
    setTimeout(function () { refresh().then(show); }, 650);
  });

  document.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || b.closest('form') || b.classList.contains('addc') || b.closest('#mcdrawer')) return;
    if ((b.textContent || '').trim().toLowerCase() !== 'adaugă în coș') return;
    var f = document.querySelector('form[action*="/cart/add"]');
    if (f) { e.preventDefault(); addFromForm(f); }
  });
})();
